<template>
    <div>
        <base-modal :isOpen="value" :title="title" @close="close" size="sm">
            <!-- Body -->
            <template #body>
                <strong class="custom-dark">{{ message }}</strong>
            </template>
            <template #footer>
                <vs-button icon="close" color="danger" type="flat" @click="close">
                    {{ $t('cancel') | capitalize }}
                </vs-button>

                <vs-button icon="check" color="success" type="flat" @click="accept">
                    {{ $t('accept') | capitalize }}
                </vs-button>
            </template>
        </base-modal>
    </div>
</template>

<script setup>
import BaseModal from '@/views/app/components/BaseModal.vue'

const emit = defineEmits(['accept', 'close'])

const props = defineProps({
    value: { type: Boolean, default: false },
    item: { type: Object, default: () => ({}) },
    message: { type: String, default: 'message' },
    title: { type: String, default: 'title' }
})

const close = () => {
    emit('input', false)
}

const accept = () => {
    emit('accept', { ...props.item })
}

</script>
